// Turn Role Router — política PURA de roteamento por papel do turno (role → destino).
//
// Espelha o mapeamento `proxy.ts role→destination` para turnos de LLM. Módulo SEM
// import algum: dado um papel, devolve a política de execução do turno.
//
// INVARIANTES SEMÂNTICAS (a lei desta camada):
// - `permissionsMode` é `null` ("não mexe") ou `'ask'` ("aperta para perguntar").
//   NUNCA é `'ignore'`: o roteador SÓ APERTA, jamais relaxa uma permissão.
//   Esta é a lei `arch:only-tightens`.
// - `readOnly:true` apenas REMOVE ferramentas mutadoras (segurança aditiva); nunca
//   concede uma nova ferramenta.
// - Cada chamada devolve um objeto NOVO (nunca um singleton mutável compartilhado),
//   de modo que quem chama não consiga mutar a tabela.

/** Papéis de turno reconhecidos pelo roteador. */
export const ROLES = {
  ANALYSIS: 'analysis',
  BUILD: 'build',
  RISKY: 'risky',
  CHAT: 'chat',
  NONE: 'none',
};

/**
 * Resolve a política de execução de um turno a partir do seu papel.
 *
 * Papel desconhecido/inválido/ausente recai sobre a política de 'none' — o no-op
 * seguro (nada é apertado, nada é relaxado).
 *
 * @param {string} role - um dos valores de {@link ROLES}.
 * @returns {{ readOnly: boolean, permissionsMode: 'ask'|null, modelTier: 'cheap'|'keep' }}
 *   objeto NOVO a cada chamada.
 */
export function policyForRole(role) {
  switch (role) {
    case ROLES.ANALYSIS:
      return { readOnly: true, permissionsMode: null, modelTier: 'cheap' };
    case ROLES.CHAT:
      return { readOnly: true, permissionsMode: null, modelTier: 'cheap' };
    case ROLES.BUILD:
      return { readOnly: false, permissionsMode: null, modelTier: 'keep' };
    case ROLES.RISKY:
      return { readOnly: false, permissionsMode: 'ask', modelTier: 'keep' };
    case ROLES.NONE:
    default:
      // 'none' e QUALQUER papel desconhecido/ausente: o no-op seguro.
      return { readOnly: false, permissionsMode: null, modelTier: 'keep' };
  }
}
